export default __webpack_public_path__ + "static/media/logo.69df7091.svg";